module.exports = __webpack_public_path__ + "static/media/percentage_bg.3bdbbfb1.png";